(function () {
  const MENU_CONTAINER = "#outing-event-dashboard-menu";
  const MAIN_MENU_SELECTOR = "[data-menu='main']";
  const SUBMENU_SELECTOR = "[data-submenu]";

  const showMainMenu = ($container) => {
    const $mainMenu = $container.find(MAIN_MENU_SELECTOR);
    const $submenus = $container.find(SUBMENU_SELECTOR);

    $submenus.addClass("d-none");
    $mainMenu.removeClass("d-none");
  };

  const showSubmenu = ($container, submenuId) => {
    const $mainMenu = $container.find(MAIN_MENU_SELECTOR);
    const $submenus = $container.find(SUBMENU_SELECTOR);
    const $targetSubmenu = $container.find(`[data-submenu='${submenuId}']`);

    if (!$targetSubmenu.length) return;

    $mainMenu.addClass("d-none");
    $submenus.addClass("d-none");
    $targetSubmenu.removeClass("d-none");
  };

  const init = () => {
    const $container = $(MENU_CONTAINER);
    if (!$container.length) return;

    showMainMenu($container);

    $container.on("click", "[data-action='open-submenu']", function (event) {
      event.preventDefault();
      const submenuId = $(this).data("submenuTarget");
      if (!submenuId) return;

      showSubmenu($container, submenuId);
    });

    $container.on(
      "click",
      "[data-action='back-to-main'], [data-action='close-submenu']",
      function (event) {
        event.preventDefault();
        showMainMenu($container);
      }
    );

    $container.on('click', '.show-mobile-code', function(e) {
      window.stopEvent(e);

      window.swalConfirm.fire({
        title: null,
        icon: 'info',
        text: `The event code is ${gon.event.code}.`,
        showCancelButton: false,
        confirmButtonText: 'Close',
      });
    });
  };

  $(document).on("turbolinks:load", init);
})();
